import { DatePicker } from 'antd';
import React, { useMemo } from 'react';
// import locale from "antd/lib/date-picker/locale/it_IT";
import { Moment } from '../../../utils/helpers/date_helpers';

interface DateFieldProps {
  name?: string;
  placeholder?: string;
  defaultValue?: any;
  onChanged?: (any) => any;
  format?: string;
  showToday?: boolean;
  value?: any;
  returnFormat?: string;
  onChange?: any;
  returnAsString?: boolean;
  type?: 'date' | 'dateRange';
}
const DateField: React.FC<DateFieldProps> = React.forwardRef(
  (
    {
      placeholder,
      onChanged,
      showToday = false,
      name,
      type = 'date',
      format = 'DD/MM/YYYY',
      returnFormat = undefined,
      returnAsString = false,
      onChange,
      ...props
    },
    ref
  ) => {
    const internalChange = (momentDate, dateStrings) => {
      //debugger;
      let newDate: any = momentDate;
      if (returnFormat) {
        if (Array.isArray(momentDate)) {
          newDate = momentDate.map((val) => Moment(val).format(returnFormat));
        } else {
          newDate = Moment(momentDate).format(returnFormat);
        }
      }
      if (returnAsString) {
        newDate = dateStrings;
      }

      onChange && onChange(newDate);
    };

    const valueDate = useMemo(() => {
      if (type === 'dateRange') {
        if (!props.value || props.value === 'Invalid date') return [,];

        if (Array.isArray(props.value)) {
          return props.value.map((val) => (!Moment.isMoment(val) ? Moment(val) : val));
        }

        return props.value;
      }

      return props.value && !Moment.isMoment(props.value)
        ? Moment(props.value)
        : props?.value || undefined;
    }, [props.value]);

    if (type === 'dateRange') {
      return (
        <DatePicker.RangePicker
          {...props}
          onChange={internalChange}
          format={format}
          className="input date dateRange"
          // @ts-ignore
          value={valueDate}
        />
      );
    }
    // const [dateMode, setDateMode] = React.useState(mode || 'date')
    return (
      <DatePicker
        {...props}
        // @ts-ignore
        defaultPickerValue={showToday && Moment()}
        // defaultValue={showToday && Moment()}
        //	mode={dateMode}
        onChange={internalChange}
        placeholder={placeholder}
        // @ts-ignore
        value={valueDate}
        format={format}
        className="input date"
        style={{ width: '100%' }}

      // open={isOpen}
      />
    );
  }
);

export default DateField;
